import { getApiBaseUrl, getApiClient } from "./serviceconfig";

var apiBaseUrl = getApiBaseUrl();

export async function updateSettings(cookies, inputs, settingsId) {
    return getApiClient(cookies)
    .put(`${apiBaseUrl}/settings/${settingsId}/`, inputs)
}

export async function getSettingsDetails(cookies) {
  return getApiClient(cookies).get(`${apiBaseUrl}/settings/`)
  .then(response => response.data)
}

export async function getListViewSettings(cookies, viewKey) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/settings/list_view/?view_key=${viewKey}`)
    .then(response => response.data);
}

export async function saveListViewSettings(cookies, viewKey, config) {
  return getApiClient(cookies)
    .put(`${apiBaseUrl}/settings/list_view/`, { view_key: viewKey, config })
    .then(response => response.data);
}
